




















































































































import { Component, Emit, Prop, Vue, Watch } from "vue-property-decorator";
import * as rules from '@/rules'
import { Urls } from "@/Urls";
import { getModule } from "vuex-module-decorators";
import Decisions from "@/store/modules/Decisions";
import Modelling from "@/store/modules/Modelling";
import { Factor, FactorGroup, FactorResource } from '@/api/model/FactorResource';
import { Stream } from 'stream';
import Viewpoints from '@/store/modules/Viewpoints';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import _ from 'lodash';
import Choices from "@/store/modules/Choices";

const decisionsModule = getModule(Decisions)
const modellingModule = getModule(Modelling)
const viewpointsModule = getModule(Viewpoints);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const choicesModule = getModule(Choices)

const papa = require('papaparse');


@Component({
    components: {}
})

export default class ChoiceMappingTables extends Vue {

    @Prop({default: false, type: Boolean})
    dialog!: boolean;

    @Prop({default: false, type: File})
    file!: File;

    @Prop({default: () => ([]), type: Array})
    headers!: String[];
    
    @Prop({default: () => ([]), type: Array}) 
    csvHeaders!:  {column: number, name: string}[];

    @Prop({default: '', type: String})
    rootId!: String;

    @Prop({default: true, type: Boolean})
    isChoice!: boolean

    private list: string = '';
    
    private createForm: { name?: string, csvColumns: {[key: string]: {}}, typeFactorMap: {[key: string]: {}}  } = {
        csvColumns: {},
        typeFactorMap: {}

    }
        
    requiredRule = [
        rules.REQUIRED
    ];

    $refs!: {
        form: HTMLFormElement
    };

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }


    get factorResourceTree() {
        if (this.factorResources && this.factorResources['M']) {
            return this.getFactorTree(this.rootId, 'root');
        }
    }

    get factorResources() {
        return modellingModule.publishedModelFactorResources
    }

    get contributingFactors() {
        return viewpointsModule.contributingFactorResources
    }

    get contributingVisibility() {
        return workspaceOptionsModule.contributingFactorVisibility
    }

    get heads() {
        return this.csvHeaders;
    }

    get lastChoiceMapping() {
        return choicesModule.lastChoiceMapping
    }

    get isLastChoiceMappingEmpty() {
        if (_.isEmpty(this.lastChoiceMapping) && Vue.$cookies.get('vp-choice-mapping') == null) {
            return true
        } 

        if (Vue.$cookies.get('vp-choice-mapping') != null && Vue.$cookies.get('vp-mapping-decision') != decisionsModule.selectedDecisionId) {
            return true;
        }
        return false
    }


    private getFactorTree(groupId: String, parent: String) {
        let subGroupList: any[] = [];
        let filteredFactorGroups: any[] = Object.values(this.factorResources)
        
        let currentRoot: FactorGroup[] = Object.values(this.factorResources)
            .filter((f: any) => f.id === (groupId))
            .map((f: any) => f as FactorGroup)

            if(groupId === 'M') {
                subGroupList.push(currentRoot[0]);
            }

        let factorGroups: any[] = Object.values(currentRoot).map((f: any) => f as FactorGroup)

        let childFactors = (factorGroups) ? (factorGroups[0].childrenIds): undefined
        
        for (let fg in childFactors) {
            let group = filteredFactorGroups.find((f: FactorResource) => f.id === childFactors[fg]);
            parent = (group.groupTypeDefinition) ? (group.groupTypeDefinition.type): undefined
            if(parent !== "TABLE_COLUMN") {
                subGroupList.push(group);

                let subList = this.getFactorTree(group.id, parent);
                subGroupList = subGroupList.concat(subList);
            }
        }

        return subGroupList;
    }

    private constructSubTree(resources: any[], factorGroupId: string): any {
        return resources.filter(f => f.includes(factorGroupId))
            .sort((a, b) => a.displayOrder - b.displayOrder)
            .map(f => {
                if (f.type === 'FACTOR_GROUP') {
                    return {
                        id: f.id,
                        name: f.name,
                        type: 'FACTOR_GROUP',
                        children: this.constructSubTree(resources, f.id)
                    }
                }
                return {
                    id: f.id,
                    name: f.name,
                    type: 'FACTOR',
                    dataField: f.dataField,
                    valueType: f.valueType
                }
            })
    }

    get isDisabled() {
        if (this.list!==undefined && this.list.trim()) {
            return false;
        } else {
            return true;
        }
    }

    @Watch('dialog')
    dialogChange() {
        if (!this.list) {
            this.$refs.form.reset();
        }
    }

    private onChangeUpdateMapping(item: any) {
        if(item.id !== 'M')
            (this.createForm.csvColumns[item.dataField] >= 0)? this.createForm.typeFactorMap[item.dataField] = item.valueTypeDefinition.valueType : delete this.createForm.typeFactorMap[item.dataField];
        
        if(this.isChoice) {
            choicesModule.saveChoiceMapping({map: this.createForm.csvColumns, typeMap: this.createForm.typeFactorMap})
            Vue.$cookies.set('vp-choice-mapping', {map: this.createForm.csvColumns, typeMap: this.createForm.typeFactorMap});
            Vue.$cookies.set('vp-mapping-decision', decisionsModule.selectedDecisionId);
        }
        this.$emit('mapping', this.createForm.csvColumns, this.createForm.typeFactorMap);
    }

    private restoreMapping() {
        if(this.lastChoiceMapping != null && this.lastChoiceMapping.map) {
            this.createForm.csvColumns = this.lastChoiceMapping.map
            this.createForm.typeFactorMap = this.lastChoiceMapping.typeMap
        } else if(Vue.$cookies.get('vp-choice-mapping') != null) {
            const cookieObject = Vue.$cookies.get('vp-choice-mapping')
            this.createForm.csvColumns = cookieObject.map;
            this.createForm.typeFactorMap = cookieObject.typeMap;
        }

        this.$emit('mapping', this.createForm.csvColumns, this.createForm.typeFactorMap);

    }

    private clear() {
        this.createForm.csvColumns = {};
        this.createForm.typeFactorMap = {}
    }

    private autoMap() {
        this.createForm.typeFactorMap = {};
        this.createForm.csvColumns = {};
        Object.values(this.factorResources).map((factor: Factor) => {
            //Only map factor type factors or M level which is treated as choice name
            if(factor.type === 'FACTOR' || factor.id == 'M') {
                const index = this.csvHeaders.find(header => header.name.toUpperCase().trim() === factor.name.toUpperCase().trim())
                if(index !=  null) {
                    if(factor.id != 'M') {
                        Vue.set(this.createForm.csvColumns, factor.dataField, index.column)
                        Vue.set(this.createForm.typeFactorMap, factor.dataField, factor.valueTypeDefinition.valueType)
                    } else {
                        //Don't add typemap value if M factor since it's the choice name
                        Vue.set(this.createForm.csvColumns, factor.id, index.column)

                    }
                } 
            }
        })

        if(this.isChoice) {
            choicesModule.saveChoiceMapping({map: this.createForm.csvColumns, typeMap: this.createForm.typeFactorMap})
            Vue.$cookies.set('vp-choice-mapping', {map: this.createForm.csvColumns, typeMap: this.createForm.typeFactorMap});
            Vue.$cookies.set('vp-mapping-decision', decisionsModule.selectedDecisionId);
        }

        this.$emit('mapping', this.createForm.csvColumns, this.createForm.typeFactorMap);
    }
}

